export const isNotNull = e => e !== null;